export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_40-288da25bbde2e460521428ade67bf5f3.jpg";